import { MainContentLayout } from 'shared/ui/layout';

import { EditHub } from 'features/hub/edit';

export function EditHubPage() {
  return <MainContentLayout element={<EditHub />} />;
}
